import { makeStyles } from "@material-ui/styles";
import { Theme } from "@material-ui/core/styles";
export default makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(1),
    marginBottom: `calc(${theme.spacing(8)}px + env(safe-area-inset-bottom))`, // 40px + safe area
    backgroundColor: theme.palette.background.paper,
  },
}));
